var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('usuario-lista',{attrs:{"modulo":'GESTAO',"tipoUsuario":'CONSIGNATARIA'}})}
var staticRenderFns = []

export { render, staticRenderFns }